import React, { useContext, useEffect, useState } from 'react'

import ILogin from './login.interface'
import LoginContext from './login-context'
import Spinner from '../spinner/spinner'
import config from './../../config'
import { setLocalStorageToken } from '../auth/tokenStorage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

const Login: React.FC<ILogin> = () => {
  const { setBankIdSignup } = useContext(LoginContext)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const errors = {
    no_user: 'Ingen användare hittades',
    missing_roles: 'Användare felkonfigurerad, kontakta Fastigo för hjälp',
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    const error = urlParams.get('error')

    if (error) {
      setLocalStorageToken('')
      setError(error)
    }

    token && setLocalStorageToken(token)

    if (token) {
      window.location.href = '/'
      return
    }

    setLoading(false)
  }, [])

  const handleBankIdSignup = async (event) => {
    event.preventDefault()
    setBankIdSignup(true)
  }

  const handleLoginButton = async () => {
    window.location.href = `${config.baseApiUrl}/v1/criipto/authenticate`
  }

  return (
    <div className="h-screen flex font-sans flex-col items-center bg-bgBlueGray">
      <div className="mx-auto pb-24 mt-12">
        <img
          src={`${process.env.PUBLIC_URL}/img/logo.png`}
          alt="Fastigo logotyp"
          className="w-24 h-auto"
        />
      </div>
      {error && (
        <div
          className="fixed flex w-full top-0 right-0 bg-red shadow border-lightGray text-fastigoWhite px-8 py-2 justify-between z-50"
          role="alert"
        >
          <div className="flex">
            <FontAwesomeIcon icon={faExclamationTriangle} size="lg" color="#fff" className="mr-4" />
            <div>
              <p className="text-sm font-semibold">
                {errors[error] ?? 'Något gick fel vid inloggningen, var vänlig försök igen'}
              </p>
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div
            className="mx-2 bg-fastigoWhite shadow-sm flex flex-col py-8 myf-1 px-8 border border-darkGray mt-12 md:mx-0"
            style={{ width: 480, maxWidth: '100%' }}
          >
            <h1 className="font-semibold text-xl text-black">
              Lämna statistik och företagsuppgifter
            </h1>
            <p className="text-sm opacity-75 mt-2 mb-10">
              Logga in för att lämna de företagsuppgifter som ligger till grund för Fastigos årligen
              sammanställda årslönesummor och lönestatistik.
            </p>
            <div className="">
              <div className="py-4">
                <div className="flex flex-row">
                  <div className="flex-auto self-center">
                    <img src="/bankid.png" alt="BankID logotyp" className="w-12 h-12 m-2" />
                  </div>
                  <div className="flex-auto self-center">
                    <button onClick={handleLoginButton} className="btn" type="button">
                      Logga in med BankID
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button type="button" onClick={handleBankIdSignup}>
            <p className="text-darkBlue mt-6 text-sm">
              Kommer du inte in?{' '}
              <span className="underline hover:font-semibold">Ansök om BankID-inloggning</span> hos
              Fastigo.
            </p>
          </button>
        </>
      )}
    </div>
  )
}

export default Login
